import React from 'react';
import { RxCountdownTimer } from 'react-icons/rx';
import { useDispatch, useSelector } from 'react-redux';
import { compareOtp } from '../../../services/operations/admin';
import { useState } from 'react';
import OtpInput from 'react-otp-input';
import { useNavigate } from 'react-router-dom';

function VerifyOtp({ sendOtp, email }) {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [otp, setOtp] = useState('');
  const [userPresent, setUserPresent] = useState(true);

  const handleVerify = async (e) => {
    e.preventDefault();
    const res = await dispatch(compareOtp(otp, email, navigate));
    console.log(res)

    setUserPresent(res);
  };


  return (
    <div>
      {userPresent ? (
        <div className="min-h-[calc(100vh-3.5rem)] grid place-items-center ">
          {loading ? (
            <div>
              <div className="spinner"></div>
            </div>
          ) : (
            <div className="max-w-[500px]  p-4 lg:p-8">
              <h1 className="text-gray-900 font-semibold text-2xl lg:text-3xl">
                Verify Email
              </h1>
              <p className="text-gray-700 text-sm lg:text-base my-4">
                A verification code has been sent to you. Enter the code below
              </p>
              <form onSubmit={handleVerify}>
              <OtpInput
              value={otp}
              onChange={setOtp}
              numInputs={6}
              renderInput={(props) => (
                <input
                  {...props}
                  placeholder="-"
                  type='number'
                  style={{
                    boxShadow: "inset 0px -1px 0px rgba(255, 255, 255, 0.18)",
                  }}
                  className="w-[48px] lg:w-[60px] border-0 bg-gray-300 rounded-[0.5rem] text-richblack-5 aspect-square text-center focus:border-0 focus:outline-2 focus:outline-yellow-50"
                />
              )}
              containerStyle={{
                justifyContent: "space-between",
                gap: "0 6px",
              }}
            />
                <button
                  type="submit"
                  className="w-full bg-yellow-500 py-3 px-4 mt-6 rounded-md text-gray-900 font-semibold transition duration-300 hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2"
                >
                  Verify Email
                </button>
              </form>
              <div className="mt-6 flex items-center justify-between">
                <button
                  className="flex items-center text-blue-900 gap-x-2"
                  onClick={sendOtp}
                >
                  <RxCountdownTimer />
                  Resend it
                </button>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center mt-[120px] py-8 bg-red-100 rounded-lg shadow-md">
  <h1 className="text-2xl font-bold text-red-600 mb-4">
    Access Denied
  </h1>
  <p className="text-lg text-gray-700">
    You do not have admin access. Please contact the admin for assistance.
  </p>
</div>

      )}
    </div>
  );
}

export default VerifyOtp;
